require('./generateReportDialog.style.scss');

class GenerateReportDialogController {
    constructor($scope, $filter, $element, $timeout, persistence, notificationService) {
        this.$scope = $scope;
        this.$filter = $filter;
        this.$element = $element;
        this.$timeout = $timeout;
        this.persistence = persistence;
        this.notificationService = notificationService;
        this.modalTitle = this.$filter('translate')('report.generate.title');

    }

    $onInit() {
        this.closeId = { close: 'report-schedule-close', closeIcon: 'report-schedule-close-icon' };
        this.actionButtons = [
            { title: this.$filter('translate')('report.generate.button'), action: this.generateReport.bind(this), isDisabled: () => (this.dialogForm && !this.dialogForm.$valid) || this.busy, id: 'generate-reports' },
        ];
    }

    onOpen() {
        this.renderCounter = 0;
        this.$element.on('keydown', (e) => {
            if (e.keyCode == 13) {
                e.preventDefault();
                e.stopPropagation();
                if (this.dialogForm && !this.dialogForm.$valid) return;
                this.$timeout(() => {
                    if (!this.showModal || this.renderCounter > 0) return;
                    this.renderCounter++;
                    this.generateReport();
                }, 0);
            }
        });
    }

    onClose() {
        delete this.description;
        this.busy = false;
    }

    generateReport() {
        const data = {
            description: this.description
        };
        this.busy = this.persistence.createReportVersion(this.report, data)
            .then(res => {
                this.notificationService.pop(res.data.message);
            })
            .finally(() => {
                this.showModal = false;
                this.busy = false;
                this.onClosed();
            });
    }
}

GenerateReportDialogController.$inject = ['$scope', '$filter', '$element', '$timeout', 'reportsPersistence', 'notificationService'];

const generateReportDialogComponent = {
    controller: GenerateReportDialogController,
    template: require('./generateReportDialog.template.html'),
    bindings: {
        report: '<',
        showModal: '=',
        onClosed: '&'
    }
};

module.exports = generateReportDialogComponent;


// WEBPACK FOOTER //
// ./src/azurebackup/views/reports/dialogs/generateReportDialog/generateReportDialog.component.js